<div class="create-or-edit-collection-page-container container" fxLayout="column" fxLayoutGap="15px">

  <!-- Cloning Description with Translation Support -->
  <p>{{ 'cloneCollection.clone_message' | translate }}</p>

  <!-- Form Group -->
  <div fxLayout="column" [formGroup]="form">

    <!-- Collection Name Input -->
    <mtn-text-field
      [form]="form"
      controlName="name"
      placeholder="{{ 'cloneCollection.name_placeholder' | translate }}"
      [isRequired]="true">
    </mtn-text-field>

    <!-- Collection Description Text Area -->
    <mtn-text-area-field
      [form]="form"
      controlName="description"
      placeholder="{{ 'cloneCollection.description_placeholder' | translate }}">
    </mtn-text-area-field>

    <!-- Favorite Checkbox -->
    <mat-checkbox color="primary" formControlName="favorite" aria-label="Mark as Favorite">
      {{ 'cloneCollection.make_favorite' | translate }}
    </mat-checkbox>

  </div>

</div>
